class VariantSpotlight extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.count = this.slides.length;
    if (this.count <= 1) return;

    this.index = 0;
    this.bind();
  }

  bind() {
    this.addEventListener('click', (e) => {
      const prev = e.target.closest('[data-prev]');
      const next = e.target.closest('[data-next]');
      if (prev) this.go(-1);
      if (next) this.go(1);
    });
  }

  go(delta) {
    const next = (this.index + delta + this.count) % this.count;
    this.show(next);
  }

  show(target) {
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('hidden', i !== target);
      const counter = slide.querySelector('[data-counter]');
      if (counter) counter.textContent = `${target + 1} / ${this.count}`;
    });
    this.index = target;
  }
}

customElements.define('variant-spotlight', VariantSpotlight);
